import styled from '@emotion/styled';
import { connect } from 'react-redux';
import WithRouter from '../utilities/WithRouter';
import { setCurrentCampus, setCurrentGX } from '../actions';

import sunny_icon from '../assets/icon_weather_sun.svg';
import partly_cloudy_icon from '../assets/icon_weather_partly_cloudy.svg';
import cloudy_icon from '../assets/icon_weather_cloudy.svg';
import rain_icon from '../assets/icon_weather_rain.svg';
import snow_icon from '../assets/icon_weather_snow.svg';
import thunder_storm_icon from '../assets/icon_weather_thunderstorm.svg';
import windy_icon from '../assets/icon_weather_squall.svg';
import tornado_icon from '../assets/icon_weather_funnel.svg';
import hurricane_icon from '../assets/icon_weather_hurricane.svg';
import blizzard_icon from '../assets/icon_weather_blizzard.svg';
import fog_icon from '../assets/icon_weather_fog.svg';
import dust_icon from '../assets/icon_weather_dust.svg';
import smoke_icon from '../assets/icon_weather_smoke.svg';
import hot_icon from '../assets/icon_weather_hot.svg';
import cold_icon from '../assets/icon_weather_cold.svg';
import advisory_icon from '../assets/icon_alert.svg';

const SolarCampusTable = ({ solarCampusData, handleGXChange }) => {
  let weatherIcon = '';

  for (const campus of solarCampusData) {
    switch (campus.weatherCondition) {
      case 'Clear':
      case 'Sunny':
        weatherIcon = sunny_icon;
        break;
      case 'Partly Cloudy':
      case 'Mostly Cloudy':
        weatherIcon = partly_cloudy_icon;
        break;
      case 'Partly Cloudy':
      case 'Partly Cloudy':
        weatherIcon = cloudy_icon;
        break;
      case 'Showers':
      case 'Rain':
      case 'Sleet':
      case 'Freezing Rain':
        weatherIcon = rain_icon;
        break;
      case 'Snow':
        weatherIcon = snow_icon;
        break;
      case 'Thunderstorm':
        weatherIcon = thunder_storm_icon;
        break;
      case 'Windy':
        weatherIcon = windy_icon;
        break;
      case 'Blizzard':
        weatherIcon = blizzard_icon;
        break;
      case 'Tornado':
        weatherIcon = tornado_icon;
        break;
      case 'Hurricane':
      case 'Tropical Storm':
        weatherIcon = hurricane_icon;
        break;
      case 'Fog':
      case 'Haze':
        weatherIcon = fog_icon;
        break;
      case 'Dust':
        weatherIcon = dust_icon;
        break;
      case 'Smoke':
        weatherIcon = smoke_icon;
        break;
      case 'Hot':
        weatherIcon = hot_icon;
        break;
      case 'Cold':
        weatherIcon = cold_icon;
        break;
      case 'Heat Advisory':
        weatherIcon = advisory_icon;
        break;
      case 'Mist':
      case 'Chilly':
      case 'Unknown':
        weatherIcon = '';
        break;
      default:
        weatherIcon = '';
        break;
    }
  }

  return (
    <StyledSolarCampusTable>
      {solarCampusData && (
        <table>
          <thead>
            <tr>
              <th>Campus</th>
              <th>Meter Name</th>
              {/* <th>Wx</th> */}
              <th>Solar Size</th>
              <th>Battery Size</th>
              <th>Site Load</th>
              <th>Solar</th>
              <th>Battery</th>
              <th>Current Offset</th>
            </tr>
          </thead>

          <tbody>
            {solarCampusData.map((item, index) => (
              <tr
                key={`campus-${index}`}
                onClick={() => handleGXChange(item?.gridInterconnectEntityKeyToken)}
              >
                <td className="campus-name">{item?.shortCampusDisplayName}</td>
                <td>{item?.shortGridInterconnectDisplayName}</td>
                {/* <td>
                                    <div className="weather">
                                        {`${Math.round(item?.temperatureCelsius * 1.8) + 32} °F`}
                                        {item?.weatherCondition !== "Unknown" &&
                                            (<img 
                                                src={weatherIcon} 
                                                alt={`${item?.weatherCondition} icon`} 
                                                width="20px"
                                            />)
                                        }
                                        
                                    </div>
                                </td> */}
                <td>
                  {item.solarCapacitykWdc !== null
                    ? `${item.solarCapacitykWdc.toFixed(2)} kWdc`
                    : 'N/A'}
                </td>
                <td>
                  {`${item?.batteryPowerCapacitykW.toFixed(2)} kW /`}
                  <br />
                  {`${item?.batteryEnergyCapacitykWh.toFixed(2)} kWh`}
                </td>
                <td>{item?.siteLoadkW.toFixed(2)} kW</td>
                <td>
                  {item?.solarLoadkW < 0 || item?.solarLoadkW === null ? (
                    'N/A'
                  ) : (
                    <>{item?.solarLoadkW.toFixed(2)} kW</>
                  )}
                </td>
                <td>{item?.batteryLoadkW.toFixed(2)} kW</td>
                <td>
                  <div className="percent-container">
                    <div
                      className="offset-percent"
                      style={{
                        height: '24px',
                        width: `$${Math.round(item?.offsetPercentage)}%`,
                      }}
                    >
                      <span
                        style={{
                          position: 'absolute',
                          width: '100%',
                          textAlign: 'center',
                          left: '3%',
                        }}
                      >
                        {`${Math.round(item?.offsetPercentage)}%`}
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </StyledSolarCampusTable>
  );
};

const StyledSolarCampusTable = styled.div`
  max-height: 500px;
  overflow: hidden;
  overflow-y: scroll;

  table {
    background: white;
    border-collapse: separate;
    border-radius: 12px;
    border-spacing: 0 12px;
    padding: 0 24px;
    width: 100%;

    th {
      border-bottom: 2px solid #c2d0d1;
      text-align: left;
    }

    th:nth-of-type(n + 2),
    td:nth-of-type(n + 2) {
      text-align: center;

      button {
        justify-content: center;
      }
    }

    tr {
      height: 46px;

      &:last-of-type td {
        border-bottom: none;
      }
    }

    tbody tr {
      cursor: pointer;
    }

    thead {
      background: white;
      position: sticky;
      top: 0;
      z-index: 99;
    }

    thead,
    td:first-of-type {
      color: #02222b;
      font-size: 14px;
      font-weight: 500;
    }

    td {
      color: #02222b;
      font-size: 14px;
      font-weight: 500;

      button {
        align-items: center;
        background: white;
        border: none;
        border-radius: 8px;
        color: white;
        cursor: pointer;
        display: flex;
        font-family: 'Inter', Arial, Helvetica, sans-serif;
        font-size: 14px;
        font-weight: 600;

        img {
          transition: ease-in-out all 250ms;
        }

        &:hover img {
          opacity: 0.5;
          transition: ease-in-out all 250ms;
        }
      }
    }

    .campus-name {
      text-decoration: underline;
    }

    .weather {
      align-items: center;
      display: flex;
      gap: 4px;
      justify-content: center;
    }

    .percent-container {
      border: 1px solid #c2d0d150 !important;
      border-radius: 8px;
      justify-content: start;
      margin: 0 auto;
      padding: 0;
      position: relative;
      width: 80%;

      .impact-percent {
        background-color: #9dbece !important;
      }

      .offset-percent {
        align-items: center;
        display: flex;
        justify-content: center;
        padding: 4px;
      }
    }
  }
`;

const mapStateToProps = (state) => {
  return {
    currentCampusId: state.currentCampusId,
    currentGXId: state.currentGXId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCurrentCampus: (campusId) => {
      dispatch(setCurrentCampus(campusId));
    },
    setCurrentGX: (gxId) => {
      dispatch(setCurrentGX(gxId));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(SolarCampusTable));
